
import styles from './styles/index.module.scss';

type Props = {
  title: string,
  required?: boolean,
  children: React.ReactNode,
};

export default function Row({ title, required, children }: Props) {

  return (
    <tr className={styles.row}>
      <th className={styles.head}>
        <div className={styles.headBody}>
          {required ? <span className={styles.required}>必須</span> : <span className={styles.any}>任意</span>}
          <span className={styles.headText}>{title}</span>
        </div>
      </th>
      <td className={styles.detail}>
        {children}
      </td>
    </tr>
  );
}